<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isRequiredLots="false"
              :filterOfWorkers="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              classLots="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              classWorkers="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
            >
              <template slot="after-farm">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('common_words.activities') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.activities', activities)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.activities"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in activities"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                  <label for="">{{ $t('labor.hour_type') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.timeTypes', timeTypes)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.timeTypes"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in timeTypes"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>

      <card v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :objectSpanMethod="objectSpanMethod"
            :cellStyle="handleCellStyle"
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="false"
          >
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-2">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF()"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportToExcel()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import configTable from './salary-compliance-report-by-worker-table';
import Fuse from 'fuse.js';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import { Pagination as LPagination } from 'src/components/index';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';

export default {
  name: 'salary-compliance-report-by-worker',

  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinExport],

  components: {
    [Filter.name]: Filter,
    LPagination,
  },

  watch: {
    '$i18n.locale': 'setupTable',
  },

  data() {
    return {
      activeName: 'filter',
      valueCollapse: null,
      extraHoursByWeek: null,
      farms: [],
      activities: [],
      timeTypes: [],
      workers: [],
      tableData: [],
      pagination: {},
      tableColumns: [],
      details: false,
      rowSpanPagination: {},
      columnsToMerge: [
        'date_save',
        'worker.code',
        'total_value',
        'attach',
        'subtract',
        'daily_minimum_wage',
      ],
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        farm: [],
        activities: [],
        timeTypes: [],
        lot: [],
        workers: [],
      },
    };
  },

  computed: {
    ...configTable().Search,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    calculateSpanPagination() {
      return this.preprocessSalaryComplianceDataPagination(this.queriedData);
    },
  },

  methods: {
    handleCollapse(value) {
      this.valueCollapse = value;
    },

    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datei: data.datei,
        datef: data.datef,
        farm: data.farm,
        lot: data.lot,
        workers: data.workers,
        bySel: data.bySel,
      };
      this.details = false;
      this.getDataSalaryComplice();
    },

    getDataSalaryComplice() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/salarycompliancebyworker';
      Axios.postMasters(data)
        .then((response) => {
          if (response.data.data.labor_data.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.tableData = response.data.data.labor_data;

            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 10;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
            this.extraHoursByWeek = response.data.data.extra_hours_by_week;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    getDateWithoutTime(dateSave) {
      const date = moment(dateSave);

      if (date.isValid()) return date.format('YYYY-MM-DD');

      return dateSave ? String(dateSave).split(/[T ]/)[0] : '';
    },

    //Funciones o logica para Combinar celdas
    getSalaryComplianceGroupKey(row) {
      const dateSave = this.getDateWithoutTime(row.date_save);
      const workerCode = row.worker && row.worker.code ? row.worker.code : '';

      return `${dateSave}-${workerCode}`;
    },

    preprocessSalaryComplianceDataPagination(data) {
      let currentGroup = null;
      let currentSpan = 0;
      let startIndex = 0;

      this.rowSpanPagination = {};

      data.forEach((row, index) => {
        const groupKey = row.is_worker_total_row
          ? `worker-total-row-${index}`
          : this.getSalaryComplianceGroupKey(row);

        if (groupKey !== currentGroup) {
          if (currentGroup !== null) {
            this.rowSpanPagination[startIndex] = currentSpan;
          }

          currentGroup = groupKey;
          currentSpan = 1;
          startIndex = index;
        } else {
          currentSpan++;
        }
      });

      if (currentGroup !== null) {
        this.rowSpanPagination[startIndex] = currentSpan;
      }

      return data;
    },

    objectSpanMethod({ row, column, rowIndex }) {
      if (row.is_worker_total_row) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }

      if (!this.columnsToMerge.includes(column.property)) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }

      try {
        this.calculateSpanPagination;
      } catch (error) {
        //
      }

      if (this.rowSpanPagination[rowIndex]) {
        return {
          rowspan: this.rowSpanPagination[rowIndex],
          colspan: 1,
        };
      }

      if (
        rowIndex > 0 &&
        this.getSalaryComplianceGroupKey(this.queriedData[rowIndex - 1]) ===
          this.getSalaryComplianceGroupKey(row)
      ) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }

      return {
        rowspan: 1,
        colspan: 1,
      };
    },

    handleCellStyle({ row }) {
      if (row.is_worker_total_row) {
        return 'font-weight: 700; background-color: #f5f5f5;';
      }

      return '';
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
    },

    loadCatalogs() {
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('works/activities/field'),
        Axios.getMasters('works/timetypes/field'),
      ])
        .then(([activities, timeTypes]) => {
          this.activities = this.concatAll(activities.data.data);
          this.timeTypes = this.concatAll(timeTypes.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response && error.response.data
              ? error.response.data.message
              : error.message
          );
        });
    },

    exportToExcel() {
      const data = {
        ...this.dataFilter,
        data: this.tableData,
        name_file: `${i18n.t('labor.report_salary_compliance_by_worker')}_${
          this.dataFilter.datei
        }_${this.dataFilter.datef}.xlsx`,
        route: 'works/salarycompliancebyworker/excel',
      };

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToPDF() {
      const data = {
        ...this.dataFilter,
        data: this.tableData,
        name_file: `${i18n.t('labor.report_salary_compliance_by_worker')}_${
          this.dataFilter.datei
        }_${this.dataFilter.datef}.pdf`,
        route: 'works/salarycompliancebyworker/pdf',
      };

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.loadCatalogs();
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
